import React from 'react';
import { Typography } from '@/ui-kit';
import styles from './step-label.module.scss';
import { Trans, useTranslation } from 'react-i18next';
interface Props {
    stepNumber: number | string;
    stepsCount?: number;
}
export const StepLabel: React.FC<Props> = ({ stepNumber, stepsCount = 3 }) => {
    const { t } = useTranslation();

    return (
        <div className={styles.wrapperStep}>
            <Typography
                typeColor="gray"
                className={styles.text}
                dangerouslySetInnerHTML={{ __html: t('registration.step', { step: stepNumber, count: stepsCount }) }} />
        </div>
    );
};
